import React, { createContext, useContext, useEffect, useReducer, } from 'react';
const DebugWidget = React.lazy(() => import("./debug-widget"));
const DebugContext = createContext({});
const DEBUG_LOCAL_KEY = 'site-debug-status';
const DEBUG_INITIAL_STATE = {
    showBlockNames: false,
    showTemplateNames: false,
    showCurrentPublishState: false,
};
const debugShowReducer = (state, action) => {
    const update = Object.fromEntries(Object.entries({
        ...state,
        ...action,
        // Debug context might have old options we should remove
    }).filter(([key]) => DEBUG_INITIAL_STATE[key] !== undefined));
    try {
        localStorage.setItem(DEBUG_LOCAL_KEY, JSON.stringify(update));
        // eslint-disable-next-line no-empty
    }
    catch (e) {
        // ignore non-working localstorage
    }
    // This could probably be typed better
    return update;
};
const DebugProvider = ({ children, id }) => {
    const shouldRenderWidget = (process.env.NODE_ENV === 'development' || process.env.GATSBY_ATL_DRAFTS_MODE === "true");
    const [show, setShow] = useReducer(debugShowReducer, {}, () => DEBUG_INITIAL_STATE);
    const update = (key) => {
        setShow({ [key]: !show[key] });
    };
    useEffect(() => {
        /*
        * Update from localStorage once window is defined
        * */
        let localDebug;
        try {
            if (shouldRenderWidget) {
                localDebug = localStorage.getItem(DEBUG_LOCAL_KEY);
                if (localDebug) {
                    const parsed = JSON.parse(localDebug);
                    if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
                        setShow(parsed);
                    }
                }
            }
            // eslint-disable-next-line no-empty
        }
        catch (e) {
            // ignore non-working localstorage
        }
    }, [shouldRenderWidget]);
    return (React.createElement(DebugContext.Provider, { value: show },
        shouldRenderWidget && (React.createElement(React.Suspense, { fallback: null },
            React.createElement(DebugWidget, { update: update, id: id }))),
        children));
};
export default DebugProvider;
export const useDebug = () => {
    const ctx = useContext(DebugContext);
    if (!ctx) {
        throw new Error('useDebug is missing parent DebugProvider.');
    }
    return ctx;
};
//# sourceMappingURL=debug-provider.js.map